import { Form, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type ModuleSpecsFragment } from '../../../../api/fragments/ModuleSpecs';
import { type ConditionType } from '../../../../api/types';
import SelectField from '../../../../components/fields/SelectField';
import useConditionTypesOptions from '../../../../utilities/useConditionTypeOptions';
import ConditionsCard from './ConditionsCard';

export type AddConditionFormProps = {
    name: string;
    index: number;
    module?: ModuleSpecsFragment;
    value;
};

const renderConditionType = (conditionType: ConditionType, prefix: string, module?: ModuleSpecsFragment) => (
    <ConditionsCard conditionType={conditionType} module={module} prefix={prefix} />
);

const AddConditionForm = ({ name, index, value, module }: AddConditionFormProps) => {
    const { t } = useTranslation(['consentsAndDeclarations']);
    const { conditionTypeOptions } = useConditionTypesOptions(true);

    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            <Form layout="vertical">
                <SelectField
                    {...t('consentsAndDeclarations:fields.conditionType', {
                        returnObjects: true,
                    })}
                    key={`${name}.${index.toString()}`}
                    name={`${name}.${index}.type`}
                    options={conditionTypeOptions}
                    showSearch
                />
                {renderConditionType(value[index].type, `${name}.${index}`, module)}
            </Form>
        </Space>
    );
};

export default AddConditionForm;
